/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const HardhatBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M9.25 1.5a.75.75 0 0 0-.75.75v.38c-3.655 1.365-6.297 4.809-6.489 8.893a1.25 1.25 0 0 0 .19 2.476 9.999 9.999 0 0 0 19.597 0 1.25 1.25 0 0 0 .19-2.476c-.191-4.084-2.833-7.528-6.488-8.893v-.38a.75.75 0 0 0-1.498-.05 10.045 10.045 0 0 0-4.004 0 .75.75 0 0 0-.748-.7ZM8.5 4.804V9.75a.75.75 0 0 0 1.5 0V4.252A8.015 8.015 0 0 1 12 4c.69 0 1.36.088 2 .252V9.75a.75.75 0 0 0 1.5 0V4.804a8.003 8.003 0 0 1 4.485 6.696H4.015A8.003 8.003 0 0 1 8.5 4.804Zm11.353 10.449c.169-.408.305-.826.408-1.253H3.74A8.497 8.497 0 0 0 12 20.5a8.501 8.501 0 0 0 7.853-5.247Z" /></svg>);
const Hardhat = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={HardhatBase} {...rest} ref={ref} />);
export default Hardhat;